<template>
    <div>
        
        <WhiteSmileSecrets />
    </div>
</template>

<script>

import WhiteSmileSecrets from '../blog-details/WhiteSmileSecrets'

export default {
    components: {
        
        WhiteSmileSecrets,
    }
}
</script>